import { Building } from "lucide-react";

const whyChooseUsData = [
  {
    id: "01",
    title: "Corporate-First Mindset",
    desc: "We understand boardroom dynamics, stakeholder expectations, and the specific nuances of B2B and enterprise communication.",
    icon: <Building size={18} />, // Replace with actual React Icons
  },
  {
    id: "02",
    title: "Structured Processes",
    desc: "From pre-production to final delivery, our workflows are engineered for efficiency, transparency, and absolute reliability.",
    icon: "bi-diagram-3",
  },
  {
    id: "03",
    title: "Clear Accountability",
    desc: "Dedicated project management ensures that deadlines are met, budgets are respected, and objectives are consistently achieved.",
    icon: "bi-check2-square",
  },
  {
    id: "04",
    title: "Industry-Standard Production",
    desc: "We utilize cinema-grade equipment and state-of-the-art post-production facilities to deliver uncompromising quality.",
    icon: "bi-camera-video",
  },
];

const CorporateWHy = () => {
  return (
    <section className="corporate_why_choose_bg corporate_section">
      <div className="container">
        <div className="row g-5 align-items-center">
          {/* Left Column: Section Intro */}
          <div className="col-lg-4">
            <span className="text-accent small d-block mb-3">
              Our Advantage
            </span>
            <h2
              className="display-5 corporate_why_title fw-bold mb-4"
              style={{ color: "var(--white)" }}
            >
              Why Choose Us
            </h2>
            <p
              className="fs-6"
              style={{ color: "rgba(248, 250, 252, 0.68)", lineHeight: "1.7" }}
            >
              We do not just create media; we engineer strategic communication
              assets designed to solve complex corporate challenges.
            </p>
          </div>

          {/* Right Column: The Matrix Grid */}
          <div className="col-lg-8">
            <div className="matrix-grid">
              {whyChooseUsData.map((item) => (
                <div className="matrix-cell" key={item.id}>
                  <div className="matrix-content">
                    <div className="matrix-icon">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <h3 className="matrix-title">{item.title}</h3>
                    <p className="matrix-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateWHy;
